// extracted by mini-css-extract-plugin
export default {"s1":"GreyStuff_s1__Qpqfa","s2":"GreyStuff_s2__QXQR8","s3":"GreyStuff_s3__w3LBv","s4":"GreyStuff_s4__fPr4H","s5":"GreyStuff_s5__uIcOI"};